import React from 'react';
import { SearchBillingProfilesTable } from '@css-xp/ppc-billing-profile-table';
import validator from 'validator';
import { BillingProfilesSearchByCustomerContact } from './billing-profiles-search-by-customer-contact';

interface Props {
  searchTerm: string;
  partnerSearchContext: string;
  transactionAccountId: string;
  isDesignIteration1Enabled?: boolean;
}

const whereFilterOptionsForPartialSoldToAddressFilter = ['name', 'nameText', 'soldToAddressPartial'];

const buildFilterOptions = (searchTerm: string) => {
  const value = whereFilterOptionsForPartialSoldToAddressFilter.map((property) => {
    return { [property]: searchTerm };
  });
  return [
    {
      key: 'or',
      value: JSON.stringify(value),
    },
  ];
};

export const BillingProfilesSearch: React.FC<Props> = ({
  transactionAccountId,
  searchTerm,
  partnerSearchContext,
  isDesignIteration1Enabled,
}) => {
  if (validator.isEmail(searchTerm)) {
    return (
      <BillingProfilesSearchByCustomerContact
        transactionAccountId={transactionAccountId}
        searchTerm={searchTerm}
        partnerSearchContext={partnerSearchContext}
        shouldHideInnerHeading={isDesignIteration1Enabled}
        isDesignIteration1Enabled={isDesignIteration1Enabled}
      />
    );
  }
  return (
    <SearchBillingProfilesTable
      transactionAccountId={transactionAccountId}
      label={'Billing Profiles'}
      filterOptions={buildFilterOptions(searchTerm)}
      shouldHideInnerHeading={isDesignIteration1Enabled}
      isDesignIteration1Enabled={isDesignIteration1Enabled}
    />
  );
};
